<template>
  <b-modal
    id="modal-select-meta-event"
    v-model="showModal"
    hide-footer
    hide-header
    centered
    no-close-on-backdrop
    
  >
    <div class="p-1">
      <!-- Header -->
      <div class="mb-2">
        <h4 class="text-base font-bold text-[#333333] mb-0.5">
          Pilih Meta Event
        </h4>
        <p class="text-sm text-[#828282] mb-0">
          Pilih event yang ingin dilacak pada Agent CS AI
        </p>
      </div>

      <!-- Event Options List -->
      <div class="!space-y-3">
        <div
          v-for="event in availableOptions"
          :key="event.value"
          class="flex items-center justify-between p-1.5 px-2 rounded-lg cursor-pointer transition-colors"
          :class="[
            selectedEvents.includes(event.value)
              ? '!border-[#F97316] bg-[#FFF7ED] border-[1.5px]'
              : 'border border-[#E0E0E0] bg-white hover:border-gray-300'
          ]"
          @click="toggleEvent(event.value)"
        >
          <div>
            <div class=" font-semibold text-[#333333]">
              {{ event.name }}
            </div>
            <div class="text-sm text-[#828282] mt-0.5">
              {{ event.description }}
            </div>
          </div>

          <b-form-checkbox
            :checked="selectedEvents.includes(event.value)"
            class="mb-0 pointer-events-none"
          />
        </div>
      </div>

      <!-- Error Validation -->
      <div
        v-if="errorMessage"
        class="text-xs text-danger mt-2"
      >
        {{ errorMessage }}
      </div>

      <!-- Actions -->
      <div class="flex items-center gap-2 mt-2 pt-1 border-t border-gray-100">
        <b-button
          variant="outline-secondary"
          class="flex-1 text-xs"
          @click="onCancel"
        >
          Batal
        </b-button>
        <b-button
          variant="primary"
          class="flex-1 text-xs"
          @click="onSave"
        >
          Simpan
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { META_EVENT_DEFINITIONS } from '../config'

export default {
  name: 'ModalSelectMetaEvent',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    activeEvents: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedEvents: [],
      errorMessage: '',
      availableOptions: META_EVENT_DEFINITIONS,
    }
  },
  computed: {
    showModal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  watch: {
    value(isOpen) {
      if (isOpen) {
        this.selectedEvents = [...this.activeEvents]
        this.errorMessage = ''
      }
    },
  },
  methods: {
    toggleEvent(val) {
      this.errorMessage = ''
      const idx = this.selectedEvents.indexOf(val)
      if (idx > -1) {
        this.selectedEvents.splice(idx, 1)
      } else {
        this.selectedEvents.push(val)
      }
    },
    onCancel() {
      this.errorMessage = ''
      this.showModal = false
      this.$emit('cancel')
    },
    onSave() {
      if (this.selectedEvents.length === 0) {
        this.errorMessage = 'Minimal satu event harus dipilih.'
        return
      }
      this.$emit('save', [...this.selectedEvents])
      this.showModal = false
    },
  },
}
</script>
